import { sharedAr } from '@cold-ambulance/ui';

const ar = {
  ...sharedAr,
  common: {
    email: 'البريد الإلكتروني',
    password: 'كلمة السر',
    signIn: 'تسجيل الدخول',
    next: 'التالي',
    save: 'حفظ',
    saving: 'جارٍ الحفظ...',
    send: 'إرسال',
    confirm: 'تأكيد',
    processing: 'جاري المعالجة...',
    back: 'رجوع',
    viewAll: 'عرض الكل',
    viewDetails: 'عرض التفاصيل',
    delete: 'حذف',
    add: 'إضافة',
    yes: 'نعم',
    no: 'لا',
    loading: 'جاري التحميل...',
    submit: 'إرسال',
  },
  nav: {
    dashboard: 'لوحة التحكم',
    myRequests: 'طلباتي',
    profile: 'الملف الشخصي',
  },
  header: {
    welcome: 'مرحبًا بك',
    notifications: 'الإشعارات',
    noNotifications: 'لا توجد إشعارات جديدة',
    profileData: 'بيانات الملف الشخصي',
    logout: 'تسجيل الخروج',
    companyLogo: 'شعار الشركة',
  },
  home: {
    title: 'لوحة التحكم',
    needMedicalService: 'هل تحتاج إلى خدمة طبية؟',
    requestDescription: 'اطلب',
    requestDescriptionBold: 'سيارة إسعاف، عيادة متنقلة، او خدمات أخرى،',
    requestDescriptionEnd:
      'و سنربطك مباشرة بمزودي الخدمات المعتمدين لتأمين خدماتك المطلوبة بكل سهولة',
    requestMedicalService: 'طلب خدمة طبية',
    myRequests: 'طلباتي',
    noRequestsTitle: 'لا يوجد طلبات حاليًا',
    noRequestsDescription: 'ابدأ بإضافة طلب جديد لعرضه هنا',
    accountUnderReview: 'لا يزال المسؤول يراجع حسابك',
    defaultProjectName: 'مشروع',
    viewOffer: 'عرض العرض',
    activeService: 'خدمة نشطة',
  },
  signin: {
    title: 'تسجيل الدخول كمستخدم',
    noAccount: 'ليس لديك حساب بعد؟',
    signUp: 'سجل معنا',
    forgotPassword: 'نسيت كلمة المرور؟',
    signingIn: 'جاري التسجيل...',
  },
  signup: {
    registerWithUs: 'سجل معنا',
    haveAccount: 'لديك حساب؟',
    stepTitle: 'البيانات التفصيلية',
    confirmPassword: 'تأكيد كلمة السر',
    creatingAccount: 'جارٍ إنشاء الحساب...',
    serviceRequesterName: 'اسم طالب الخدمة',
    contactPerson: 'جهة الاتصال',
    continuing: 'جارٍ المتابعة...',
    requiredDocuments: 'الوثائق المطلوبة',
    termsAccept: 'أوافق على الشروط والأحكام',
    termsAcceptPrefix: 'أوافق على',
    termsAnd: 'و',
    privacyPolicy: 'سياسة الاستخدام والخصوصية',
    customerAgreement: 'اتفاقية اشتراك العميل في المنصة',
  },
  profile: {
    title: 'بيانات الملف الشخصي',
    generalInfo: 'معلومات عامة',
    contactInfo: 'معلومات جهة الاتصال',
    requiredDocuments: 'الوثائق المطلوبة',
    serviceProviderName: 'اسم مقدم الخدمة',
    firstName: 'الاسم الأول',
    lastName: 'اسم الاخير',
    contactJobTitle: 'المسمى الوظيفي لجهة الاتصال',
    phoneNumber: 'رقم الجوال',
  },
  placeholders: {
    companyName: 'شركة الرواد الطبية',
    firstName: 'مشاري',
    lastName: 'العنزي',
    projectManager: 'مدير المشاريع',
  },
  documents: {
    bankCertificate: 'الشهادة البنكية',
    commercialRegistration: 'السجل التجاري',
    taxCertificate: 'الشهادة الضريبية',
    zakaCertificate: 'شهادة التسجيل في هيئة الزكاة والضرائب',
    companyLogo: 'شعار الشركة',
    nationalAddress: 'شهادة العنوان الوطني',
  },
  requests: {
    myRequests: 'طلباتي',
    draftsTitle: 'المسودات',
    draftBadge: 'مسودة',
    lastSaved: 'آخر حفظ {{value}}',
    continueEditing: 'متابعة التعديل',
    deleteDraft: 'حذف المسودة',
    deleteDraftConfirmation: 'هل تريد حذف هذه المسودة؟',
    noDrafts: 'لا توجد مسودات بعد. ابدأ طلبًا جديدًا وستظهر هنا.',
    submittedRequests: 'الطلبات المرسلة',
    draftServicesCount_zero: 'لم يتم اختيار خدمات بعد',
    draftServicesCount_one: 'تم اختيار خدمة واحدة',
    draftServicesCount_two: 'تم اختيار خدمتين',
    draftServicesCount_few: 'تم اختيار {{count}} خدمات',
    draftServicesCount_many: 'تم اختيار {{count}} خدمة',
    draftServicesCount_other: 'تم اختيار {{count}} خدمة',
    draftSummaryEmpty: 'لم يتم اختيار خدمات بعد',
    requestDetails: 'تفاصيل الطلب',
    requiredService: 'الخدمة المطلوبة',
    newRequest: 'طلب خدمة جديد',
    submitRequest: 'إرسال الطلب',
    requestSentSuccess: ' تم إرسال طلبك بنجاح!',
    requestSentNotification: 'ستتلقى تنبيهًا عند ورود عروض عبر نظام الإشعارات.',
    goToDashboard: 'الذهاب إلى لوحة التحكم',
    additionalDocuments: 'تقديم مستندات إضافية',
    submitting: 'جارٍ الإرسال...',
    submitAdditionalDocs: 'تقديم المستندات الإضافية',
    searchLocation: 'ابحث عن الموقع',
  },
  services: {
    ambulanceWithDriver: 'سيارة إسعاف مع سائق',
    ambulanceWithoutDriver: 'سيارة إسعاف من دون سائق',
    ambulanceWithoutDriverAlt: 'سيارة إسعاف بدون سائق',
    ambulance4x4WithDriver: 'سيارة إسعاف 4x4 مع سائق',
    ambulance4x4WithoutDriver: 'سيارة إسعاف 4x4 من دون سائق',
    mobileClinicBasic: 'عيادة متنقلة أساسية',
    mobileClinicAdvanced: 'عيادة متنقلة متقدمة',
    medicalEquipment: 'معدة طبية',
    equipment: 'معدة',
    ambulance: 'سيارة إسعاف',
    paramedic: 'مسعف',
    nurse: 'ممرض',
  },
  newRequest: {
    serviceRequest: 'طلب خدمة',
    serviceRequestSubtitle: 'مركبات، كوادر طبية، عيادات',
    equipmentRequest: 'طلب معدات ولوازم طبية',
    equipmentRequestSubtitle: 'شراء أو تأجير من الموردين',
    changeRequestTypeTitle: 'تغيير نوع الطلب؟',
    changeRequestTypeDescription:
      'سيتم حذف ما اخترته في الأقسام الخاصة بالنوع الحالي. لا يمكن التراجع عن هذا الإجراء.',
    changeRequestTypeConfirm: 'تغيير النوع',
    serviceDetails: 'تفاصيل الخدمة المطلوبة',
    projectName: 'إسم المشروع',
    projectEntity: 'جهة المشروع',
    government: 'قطاع حكومي',
    private: 'قطاع خاص',
    serviceType: 'نوع الخدمة المطلوبة',
    ambulanceWithDriver: 'سيارة إسعاف مع سائق',
    ambulanceWithoutDriver: 'سيارة إسعاف من دون سائق',
    ambulance4x4WithDriver: 'سيارة إسعاف 4x4 مع سائق',
    ambulance4x4WithoutDriver: 'سيارة إسعاف 4x4 من دون سائق',
    basicClinic: 'عيادة متنقلة أساسية',
    advancedClinic: 'عيادة متنقلة متقدمة',
    count: 'العدد',
    specifiedEquipment: 'المعدات واللوازم الطبية المحددة',
    medicalStaffTypes: 'أنواع كوادر خدمات الطوارئ الطبية',
    paramedic: 'مسعف',
    paramedicSubtitle: 'مسعفون متقدّمو المهارة قادرون على تقديم رعاية متخصصة.',
    paramedicSpecialist: 'اخصائي مسعف',
    paramedicTechnician: 'فني مسعف',
    nurses: 'ممرضون',
    nursesSubtitle:
      'ممرضون معتمدون (SN1 بدرجة البكالوريوس، وSN2 بشهادة الدبلوم).',
    nurseSpecialist: 'اخصائي تمريض',
    nurseTechnician: 'فني تمريض',
    doctors: 'أطباء',
    doctorsSubtitle:
      'بما في ذلك الأطباء العامون (GPs) وأخصائيو الرعاية الطبية الطارئة.',
    specializationPlaceholder: 'التخصص (مثال: طبيب عام، طبيب باطني)',
    addDoctor: 'إضافة طبيب',
    medicalEquipment: 'المعدات واللوازم الطبية',
    medicalEquipmentSubtitle: 'معدات طبية إضافية غير متوفرة في سيارات الإسعاف',
    equipmentNamePlaceholder: 'مثال: جهاز تنفس اصطناعي، جهاز مراقبة القلب',
    quantity: 'الكمية',
    addEquipment: 'إضافة معدة',
    bookingPeriodLocation: 'فترة الحجز و الموقع',
    bookingPeriod: 'فترة الحجز',
    fromHour: 'من الساعة',
    toHour: 'إلى الساعة',
    bookingDuration: 'مدة الحجز:',
    workHoursPerDay: 'ساعات العمل / اليوم:',
    contractPaymentTerms: 'شروط التعاقد والدفع',
    proposalDeadline: 'آخر موعد لتقديم العروض من الموردين',
    paymentSchedule: 'جدول الدفع',
    monthly: 'شهري',
    deliverables: 'المخرجات',
    selectPaymentSplit: 'اختر نسبة الدفع',
    month: 'الشهر',
    milestones: 'المراحل',
    total: 'المجموع:',
    deliverable: 'الدفعة',
    firstPayment: 'المقدمة الاولى',
    addMilestone: 'إضافة مرحلة',
    remaining: '% متبقي',
    minTwoMilestones: 'يجب إضافة مرحلتين على الأقل',
    bankGuaranteePercent: 'نسبة الضمان البنكي',
    noBankGuarantee: '0% = لا يوجد ضمان بنكي مطلوب',
    kpis: 'مؤشرات الأداء',
    kpiPlaceholder: 'مثال: الاستجابة خلال 10 دقائق، معدل رضا العملاء 95%',
    addKpi: 'إضافة مؤشر أداء',
    kpiDescription:
      'هذه المؤشرات تحدد نسبة الاستقطاع من الدفعة النهائية (0-20%)',
    additionalDetails: 'تفاصيل أخرى',
    isolatedArea: 'طبيعة منطقة العمل (معزولة/منطقة نائية)',
    housingTransport:
      'هل سوف يتم توفير مسكن و مواصلات (من المسكن إلى مقر العمل و العكس)',
    mealsProvided: 'هل سوف يتم توفير وجبات طعام لطاقم العمل؟',
    additionalNotes: 'ملاحظات اضافية',
    optional: '(اختياري)',
    saving: 'جاري الحفظ...',
    saved: 'تم الحفظ',
    notSpecified: 'لم يتم التحديد',
    noServicesSelected: 'لم يتم اختيار خدمات',
    noStaffSelected: 'لم يتم اختيار كوادر',
    noEquipmentAdded: 'لم يتم إضافة معدات',
  },
  preview: {
    title: 'معاينة الطلب',
    hidePreview: 'إخفاء المعاينة',
    showPreview: 'عرض المعاينة',
    projectDetails: 'تفاصيل المشروع',
    medicalStaff: 'الكوادر الطبية',
    medicalEquipment: 'المعدات واللوازم الطبية',
    bookingPeriodLocation: 'فترة الحجز والموقع',
    contractPaymentTerms: 'شروط التعاقد والدفع',
    additionalDetails: 'تفاصيل أخرى',
    projectName: 'إسم المشروع',
    projectEntity: 'جهة المشروع',
    government: 'قطاع حكومي',
    private: 'قطاع خاص',
    proposalDeadline: 'آخر موعد للعروض:',
    bankGuarantee: 'ضمان بنكي:',
    paymentSystem: 'نظام الدفع:',
    kpis: 'مؤشرات الأداء:',
    isolatedArea: 'منطقة معزولة/نائية',
    housingTransport: 'مسكن ومواصلات',
    meals: 'وجبات طعام',
    notes: 'ملاحظات:',
    equipment: 'المعدات:',
    paramedics: 'المسعفين',
    nurses: 'الممرضين',
    doctorsLabel: 'الأطباء',
    specialist: 'أخصائي:',
    technician: 'فني:',
    quantityLabel: 'الكمية:',
  },
  offers: {
    allOffers: 'جميع العروض المقدمة',
    submittedOffers: 'العروض المقدمة',
    noOffersTitle: 'آخر العروض المقدمة',
    noOffers: 'لا يوجد عروض حاليًا',
    noOffersReceived: 'لم يتم استلام أي عروض حتى الآن',
    offerDetails: 'تفاصيل العرض',
    offeredPrice: 'السعر المقدم',
    submissionDate: 'تاريخ التقديم',
    offerProvider: 'مقدم العرض',
  },
  acceptOffer: {
    reviewOffer: 'مراجعة العرض',
    financialOffer: 'العرض المالي',
    previewOfferDetails: 'قم بمعاينة تفاصيل العرض المقدم',
    offerSummary: 'ملخص العرض',
    vendor: 'المورد',
    offerProvider: 'مقدم العرض',
    offerPrice: 'سعر العرض',
    platformFee: 'رسوم المنصة (١٠٪)',
    vat: 'ضريبة القيمة المضافة (١٥٪)',
    totalPrice: 'السعر الإجمالي',
    vendorNotes: 'ملاحظات المورد',
    requiredDocuments: 'المستندات المطلوبة من المورد',
    requiredDocumentsDescription:
      'سيُطلب من المورد رفع هذه المستندات قبل إتمام العقد',
    noDocumentsNeeded: 'لا أحتاج مستندات إضافية',
    documentNamePlaceholder: 'اسم المستند (مثال: سجل تجاري)',
    bankGuaranteeRequired: 'ضمان بنكي مطلوب',
    bankGuaranteeAutoAdded:
      'سيتم إضافة "كتاب الضمان البنكي" تلقائياً للمستندات المطلوبة',
    offerNotFound: 'العرض غير موجود',
    backToRequests: 'العودة للطلبات',
  },
  contract: {
    offerDetails: 'تفاصيل العرض',
    reviewOfferAndContract: 'راجع العرض والعقد وأكمل التوقيع الإلكتروني',
    financialOffer: 'العرض المالي',
    previewFinancialOffer: 'قم بمعاينة تفاصيل العرض المالي',
    vendorSignature: 'توقيع المورد',
    yourSignature: 'توقيعك',
    contractSignedSuccess: 'تم توقيع العقد بنجاح',
    contractSignedBothParties:
      'تم توقيع العقد من قبل الطرفين. يرجى رفع إثبات الدفع (TT) لإتمام العملية.',
    ttDeadline: 'الموعد النهائي لرفع إثبات الدفع:',
    awaitingVendorSignature: 'في انتظار توقيع المورد',
    awaitingVendorSignatureDescription:
      'تم توقيع العقد من جهتك بنجاح. نحن في انتظار توقيع المورد لإتمام العملية.',
    backToRequest: 'العودة للطلب',
    error: 'خطأ',
    errorLoadingData: 'حدث خطأ أثناء تحميل البيانات',
  },
  offerAccepted: {
    offerAcceptedSuccess: 'تم قبول العرض بنجاح',
    noDocumentsRequired:
      'تم إرسال العقد إلى بريدك الإلكتروني للتوقيع إلكترونياً. يمكنك متابعة حالة التوقيع.',
    viewContractStatus: 'عرض حالة العقد',
    documentsSentSuccess: 'تم إرسال طلب الوثائق الإضافية إلى المورد بنجاح',
    documentsSentDescription:
      'سيتولى فريقنا مراجعة الملفات والتواصل معك قريباً. وحالما نتأكد من صحة المستندات، سنزودك بالخطوات التالية.',
  },
  requestDetails: {
    ttUploadTitle: 'رفع إثبات التحويل البنكي',
    deadline: 'الموعد النهائي:',
    day: 'يوم',
    days: 'أيام',
    remaining: 'متبقي',
    medhubTransfer: 'حوالة MedHub (10%)',
    vendorTransfer: 'حوالة المورد (10%)',
    medhubBankInfo: 'معلومات الحساب البنكي - MedHub',
    transferToAccount: 'يرجى تحويل المبلغ إلى الحساب التالي',
    reviewedByAdmin: 'يراجعها:إدارة ميدهب',
    reviewedByVendor: 'يراجعها: المورد',
    ttRejected: 'تم رفض إثبات الدفع:',
    ttUploaded: 'تم رفع إثبات الدفع',
    awaitingReview: 'في انتظار المراجعة',
    vendorBankCertNotUploaded: 'لم يقم المورد برفع شهادة البنك بعد',
    bankCertDownloadError: 'حدث خطأ أثناء تحميل شهادة البنك',
  },
  forgotPassword: {
    title: 'هل نسيت كلمة المرور؟',
    subtitle: 'أدخل بريدك الإلكتروني لإعادة تعيين كلمة المرور.',
    emailSentTitle: 'تمت العملية بنجاح',
    emailSentSubtitle:
      'لقد أرسلنا رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني.',
    setNewPassword: 'ضبط كلمة مرور جديدة',
    setNewPasswordSubtitle: 'يرجى إدخال كلمة المرور الجديدة لتحديث حسابك.',
    newPassword: 'كلمة المرور الجديدة',
    confirmNewPassword: 'تأكيد كلمة المرور الجديدة',
    passwordChanged:
      'تم تغيير كلمة المرور بنجاح، جاري تحويلك إلى صفحة تسجيل الدخول...',
    passwordChangedTitle: 'تم تغيير كلمة المرور بنجاح!',
    useNewPassword: 'يمكنك استخدام كلمة المرور الجديدة.',
    invalidCode: 'رمز التحقق غير صالح أو منتهي الصلاحية',
    errorOccurred: 'حدث خطأ',
    backToRecovery: 'العودة إلى استعادة كلمة المرور',
  },
  errors: {
    resetLinkNotFound: 'لم يتم العثور على رابط إعادة تعيين كلمة المرور',
    verificationCodeNotFound: 'لم يتم العثور على رمز التحقق في الرابط',
    verificationCodeInvalid: 'رمز التحقق غير صالح أو منتهي الصلاحية',
    accountUnderReview: 'لا يزال المسؤول يراجع حسابك',
  },
} as const;

export default ar;
